import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import {
  applicationIdValidatorMessage,
  authorizedPersonnelMustHaveShareholderValidatorMessage,
  emailValidatorMessage,
  mustHaveAuthorisedSignatoryValidatorMessage,
  mustHaveDirectorValidatorMessage,
  mustHaveKeymanValidatorMessage,
  mustHaveShareholderValidatorMessage,
  mustHaveSoleProprietorValidatorMessage,
  onlyOneKeymanValidatorMessage,
} from './message';
import {
  applicationIdValidator,
  appointmentAsyncValidator,
  customEmailValidator,
  genderValidator,
  keymanValidator,
  mustHaveAuthorisedSignatoryValidator,
  mustHaveShareholderValidator,
} from './validator';

@NgModule({
  imports: [
    FormlyModule.forChild({
      validationMessages: [
        { name: 'application-id', message: applicationIdValidatorMessage },
        { name: 'email-custom', message: emailValidatorMessage },
        { name: 'only-one-keyman', message: onlyOneKeymanValidatorMessage },
        { name: 'must-have-keyman', message: mustHaveKeymanValidatorMessage },
        { name: 'must-have-sole-proprietor', message: mustHaveSoleProprietorValidatorMessage },
        { name: 'must-have-director', message: mustHaveDirectorValidatorMessage },
        {
          name: 'authorized-personnel-must-have-shareholder',
          message: authorizedPersonnelMustHaveShareholderValidatorMessage,
        },
        { name: 'must-have-authorized-signatory', message: mustHaveAuthorisedSignatoryValidatorMessage },
        { name: 'must-have-shareholder', message: mustHaveShareholderValidatorMessage },
      ],
      validators: [
        { name: 'application-id', validation: applicationIdValidator },
        { name: 'email-custom', validation: customEmailValidator },
        { name: 'gender', validation: genderValidator },
        { name: 'appointment-async', validation: appointmentAsyncValidator },
        { name: 'must-have-authorized-signatory', validation: mustHaveAuthorisedSignatoryValidator },
        { name: 'must-have-shareholder', validation: mustHaveShareholderValidator },
        { name: 'only-one-keyman', validation: keymanValidator },
      ],
    }),
  ],
})
export class FormValidationModule {}
